// {"jsonrpc":"2.0","method":"scheduleJob","id":8,"params":{"sessionUuid":"0ea951fb-1560-4892-b783-5ca897a062fd","serverUid":"d4bd4710-1765-4476-8969-09ab9d0b676f",
// "name":"afsfd-Schedule",
// "templateUid":"f8961b32-277d-4360-86e1-40a989c8163a",
// "interval":"weekly","intervalStart":1,"endTime":"29 Dec 2023"}}
//
// {"id":8,"jsonrpc":"2.0","result":{"errorMessage":"","success":true,"uid":"a0de0824-5f7f-0000-8d00-000000000000"}}
//
// -- SÅ SKAL VI BARE HUSKE AT INVALIDATE CACHE FOR REPORTS

import { Session } from '@ais-ui/auth';
import { ReportBackendTypes } from './createReports';

export interface ScheduleResponse {
  errorMessage: string;
  success: boolean;
  uid: string;
}

export const scheduleReport = async (
  session: Session,
  templateId: string,
  name: string,
  interval: string,
  intervalStart: number,
  endTime: string,
): Promise<ScheduleResponse> => {
  const response: ScheduleResponse = await session.request('scheduleJob', {
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
    templateUid: templateId,
    name: name,
    interval: interval,
    intervalStart: intervalStart,
    endTime: endTime,
  });

  return response;
};

// Keys that belong to UI settings and should never be sent to backend as report params
const SETTINGS_KEYS_TO_FILTER = [
  'assetDisplay.mapengine',
  'ribbonPlugin.settings',
  'wmsSettings',
  'vectorTiles',
  'homeBookmark',
  'show_ports',
  'favorite_port',
  'favorite_port_data',
  'showTargetCountBadge',
  'user_settings',
  'bookmarks',
];

/**
 * Removes any UI settings keys that may have accidentally been included in report params.
 * This is a safety measure to prevent settings from being stored with reports.
 */
function sanitizeReportParamsString(paramsJson: string): string {
  try {
    const params = JSON.parse(paramsJson);
    for (const key of SETTINGS_KEYS_TO_FILTER) {
      if (key in params) {
        delete params[key];
      }
    }
    return JSON.stringify(params);
  } catch {
    // If parsing fails, return original string
    return paramsJson;
  }
}

export async function updateReportTemplateAndReport<
  T extends ReportBackendTypes,
>(session: Session, type: T, params: string): Promise<string> {
  const sanitizedParams = sanitizeReportParamsString(params);
  const response = await session.request('createJob', {
    type: type,
    params: sanitizedParams,
    action: 'OnlyUpdateTemplate',
  });

  return response;
}
